(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collab-collector"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const register = async () => {
        const { Component } = await import('@theme/component');
        
        if (customElements.get("collab-collector")) return;
        class CollabCollector extends Component {
        
      abort;
      index = 0;
      connectedCallback() { super.connectedCallback(); this.setup(); }
      updatedCallback() { super.updatedCallback(); this.setup(); }
      setup() {
        this.abort?.abort(); this.abort = new AbortController();
        this.querySelector('[data-tabs]')?.setAttribute('role', 'tablist');
        this.querySelectorAll('[data-tab]').forEach(tab => tab.setAttribute('role', 'tab'));
        this.querySelectorAll('[data-panel]').forEach(panel => panel.setAttribute('role', 'tabpanel'));
        this.addEventListener('click', event => {
          if (!(event.target instanceof Element)) return;
          const tab = event.target.closest('[data-tab]');
          if (tab) this.select(Number(tab.dataset.tab));
          if (event.target.closest('[data-prev]')) { this.select(this.index - 1); this.querySelector('[data-panel]:not([hidden]) [data-prev]')?.focus(); }
          if (event.target.closest('[data-next]')) { this.select(this.index + 1); this.querySelector('[data-panel]:not([hidden]) [data-next]')?.focus(); }
        }, { signal: this.abort.signal });
        this.addEventListener('keydown', event => {
          if (!(event.target instanceof Element) || !event.target.closest('[data-tab]')) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this).direction === 'rtl';
          const direction = (event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1);
          const count = this.querySelectorAll('[data-tab]').length;
          this.select(event.key === 'Home' ? 0 : event.key === 'End' ? count - 1 : this.index + direction, true);
        }, { signal: this.abort.signal });
        this.closest('.shopify-section')?.addEventListener('shopify:block:select', event => {
          if (!(event.target instanceof Element)) return;
          const panel = event.target.closest('[data-panel]');
          if (panel) this.select(Number(panel.dataset.panel));
        }, { signal: this.abort.signal });
        this.select(this.index);
      }
      /** @param {number} index @param {boolean} [focus] */
      select(index, focus = false) {
        const tabs = this.querySelectorAll('[data-tab]');
        if (!tabs.length) return;
        this.index = (index + tabs.length) % tabs.length;
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === this.index)); tab.tabIndex = i === this.index ? 0 : -1; });
        this.querySelectorAll('[data-panel]').forEach((panel, i) => { panel.hidden = i !== this.index; });
        if (focus) tabs[this.index]?.focus();
      }
      disconnectedCallback() { this.abort?.abort(); super.disconnectedCallback(); }
    
        }
        customElements.define("collab-collector", CollabCollector);
      };
      register().catch(error => console.error('Collaboration component failed to load', error));
    })();
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collab-details"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const register = async () => {
        const { Component } = await import('@theme/component');
        
        if (customElements.get("collab-details")) return;
        class CollabDetails extends Component {
        
      abort;
      connectedCallback() { super.connectedCallback(); this.setup(); }
      updatedCallback() { super.updatedCallback(); this.setup(); }
      setup() {
        this.abort?.abort(); this.abort = new AbortController();
        this.addEventListener('click', event => {
          if (!(event.target instanceof Element)) return;
          const button = event.target.closest('[data-detail]');
          if (button) this.select(Number(button.dataset.detail));
        }, { signal: this.abort.signal });
        this.closest('.shopify-section')?.addEventListener('shopify:block:select', event => {
          if (!(event.target instanceof Element)) return;
          const panel = event.target.closest('[data-detail-panel]');
          if (panel) this.select(Number(panel.dataset.detailPanel));
        }, { signal: this.abort.signal });
        this.select(0);
      }
      /** @param {number} index - Selected detail, zero based. */
      select(index) {
        this.querySelectorAll('[data-detail]').forEach((button, i) => {
          button.setAttribute('aria-pressed', String(i === index));
          button.classList.toggle('selected', i === index);
        });
        this.querySelectorAll('[data-detail-panel]').forEach((panel, i) => { panel.hidden = i !== index; });
      }
      disconnectedCallback() { this.abort?.abort(); super.disconnectedCallback(); }
    
        }
        customElements.define("collab-details", CollabDetails);
      };
      register().catch(error => console.error('Collaboration component failed to load', error));
    })();
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collab-film"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const register = async () => {
        const { Component } = await import('@theme/component');
        
        if (customElements.get("collab-film")) return;
        class CollabFilm extends Component {
        
      /** @type {IntersectionObserver | undefined} */
      observer;
      /** @type {AbortController | undefined} */
      abort;
      connectedCallback() { super.connectedCallback(); this.setup(); }
      updatedCallback() { super.updatedCallback(); this.setup(); }
      setup() {
        this.cleanup();
        const video = this.querySelector('video');
        if (!(video instanceof HTMLVideoElement) || this.dataset.autoplay !== 'true') return;
        this.abort = new AbortController();
        const media = matchMedia('(prefers-reduced-motion: reduce)');
        media.addEventListener('change', () => { if (media.matches) video.pause(); }, { signal: this.abort.signal });
        this.observer = new IntersectionObserver(entries => {
          if (media.matches) return;
          if (entries[0]?.isIntersecting) video.play().catch(() => {});
          else video.pause();
        }, { threshold: .2 });
        this.observer.observe(video);
      }
      cleanup() { this.observer?.disconnect(); this.abort?.abort(); }
      disconnectedCallback() { this.cleanup(); this.querySelector('video')?.pause(); super.disconnectedCallback(); }
    
        }
        customElements.define("collab-film", CollabFilm);
      };
      register().catch(error => console.error('Collaboration component failed to load', error));
    })();
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collab-purchase"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const register = async () => {
        const { Component } = await import('@theme/component');
        const { StandardEvents } = await import('@shopify/events'); const { morph } = await import('@theme/morph'); const { getScrollEventTarget, getIntersectionRoot, scrollContainerMediaQuery } = await import('@theme/scroll-container');
        if (customElements.get("collab-purchase")) return;
        class CollabPurchase extends Component {
        
      /** @type {AbortController | undefined} */
      abort;
      /** @type {AbortController | undefined} */
      scrollAbort;
      /** @type {IntersectionObserver | undefined} */
      observer;
      /** @type {MutationObserver | undefined} */
      dialogs;
      /** @type {ReturnType<typeof setTimeout> | undefined} */
      timer;
      scrolling = false;
      inPurchase = true;
      generation = 0;
      pending = false;
      stickyVariantPending = false;
      connectedCallback() { super.connectedCallback(); this.setup(); }
      updatedCallback() { super.updatedCallback(); this.observePurchase(); }
      setup() {
        this.cleanup(); this.abort = new AbortController();
        this.pending = false;
        this.stickyVariantPending = false;
        const { signal } = this.abort;
        scrollContainerMediaQuery.addEventListener('change', () => this.observePurchase(), { signal });
        this.addEventListener('click', event => this.handleClick(event), { signal });
        this.addEventListener('change', event => this.handleVariantChange(event), { signal });
        this.addEventListener('focusout', () => queueMicrotask(() => { if (!signal.aborted) this.visibility(); }), { signal });
        this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, event => this.handleProductSelect(event), { signal });
        this.observePurchase();
      }
      observePurchase() {
        this.observer?.disconnect(); this.dialogs?.disconnect();
        this.scrollAbort?.abort(); this.scrollAbort = new AbortController();
        getScrollEventTarget().addEventListener('scroll', () => {
          this.scrolling = true; this.visibility(); clearTimeout(this.timer);
          this.timer = setTimeout(() => { this.scrolling = false; this.visibility(); }, 220);
        }, { passive: true, signal: this.scrollAbort.signal });
        const zoom = this.querySelector('[data-zoom]');
        if (zoom instanceof HTMLElement) zoom.hidden = false;
        const main = this.querySelector('[data-purchase-main]');
        const bar = this.querySelector('[data-collab-sticky]');
        if (bar instanceof HTMLElement && main) {
          bar.hidden = false;
          const root = getIntersectionRoot();
          this.inPurchase = main.getBoundingClientRect().top <= (root?.getBoundingClientRect().bottom ?? window.innerHeight);
          this.observer = new IntersectionObserver(entries => {
            const entry = entries[0];
            if (!entry) return;
            this.inPurchase = entry.isIntersecting || entry.boundingClientRect.top <= (entry.rootBounds?.top ?? 0);
            this.visibility();
          }, { root });
          this.observer.observe(main);
          this.dialogs = new MutationObserver(() => this.visibility());
          this.dialogs.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
        }
        this.visibility();
      }
      visibility() {
        const bar = this.querySelector('[data-collab-sticky]');
        if (!(bar instanceof HTMLElement)) return;
        const editing = bar.contains(document.activeElement) || this.stickyVariantPending;
        const visible = (!this.scrolling || editing) && !this.inPurchase && !document.querySelector('dialog[open]');
        // Full featured-product morphs may replay the server's initial hidden state.
        bar.hidden = false;
        bar.inert = !visible;
        bar.setAttribute('aria-hidden', String(!visible));
        bar.classList.toggle('is-visible', visible);
      }
      /** @param {MouseEvent} event */
      handleClick(event) {
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('[data-floating-add]') && !this.pending) {
          const button = this.querySelector('product-form-component button[ref="addToCartButton"]');
          if (button instanceof HTMLButtonElement && !button.disabled) button.click();
        }
        const thumbnail = event.target.closest('[data-gallery-src]');
        const image = this.querySelector('[data-gallery-main]');
        if (thumbnail instanceof HTMLAnchorElement && image instanceof HTMLImageElement) {
          event.preventDefault(); image.removeAttribute('srcset'); image.src = thumbnail.dataset.gallerySrc || thumbnail.href; image.alt = thumbnail.dataset.galleryAlt || '';
        }
        const dialog = this.querySelector('dialog');
        if (event.target.closest('[data-zoom]') && dialog instanceof HTMLDialogElement && image instanceof HTMLImageElement) {
          const enlarged = dialog.querySelector('img');
          if (enlarged) { enlarged.src = image.currentSrc || image.src; enlarged.alt = image.alt; }
          if (!dialog.open) dialog.showModal();
        }
        if (event.target.closest('[data-close-zoom]') && dialog instanceof HTMLDialogElement) dialog.close();
      }
      /** @param {Event} event */
      handleVariantChange(event) {
        if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-floating-variant]')) return;
        const option = this.querySelector(`variant-picker [data-variant-id="${CSS.escape(event.target.value)}"]`);
        if (option instanceof HTMLInputElement) { option.checked = true; option.dispatchEvent(new Event('change', { bubbles: true })); }
        else if (option instanceof HTMLOptionElement && option.parentElement instanceof HTMLSelectElement) {
          option.parentElement.value = option.value; option.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      /** @param {import('@shopify/events').ProductSelectEvent} event */
      async handleProductSelect(event) {
        if (!(event.target instanceof Element) || !this.contains(event.target) || event.target.closest('product-card')) return;
        const generation = ++this.generation;
        const signal = this.abort?.signal;
        const focusedVariant = this.querySelector('[data-floating-variant]') === document.activeElement;
        this.stickyVariantPending = focusedVariant;
        const restoreFocus = () => {
          const select = this.querySelector('[data-floating-variant]');
          const bar = this.querySelector('[data-collab-sticky]');
          if (focusedVariant && select instanceof HTMLSelectElement && bar?.classList.contains('is-visible') &&
            (document.activeElement === document.body || document.activeElement === select)) {
            select.focus({ preventScroll: true });
          }
        };
        this.pending = true;
        this.querySelector('[data-collab-sticky]')?.setAttribute('aria-busy', 'true');
        const button = this.querySelector('[data-floating-add]');
        if (button instanceof HTMLButtonElement) button.disabled = true;
        try {
          const { detail } = await event.promise;
          if (generation !== this.generation || signal?.aborted) return;
          const incoming = detail?.html?.querySelector('[data-collab-sticky]');
          const current = this.querySelector('[data-collab-sticky]');
          if (incoming && current) morph(current, incoming, { childrenOnly: true });
          const image = this.querySelector('[data-gallery-main]');
          const color = String(detail?.resource?.option1 || detail?.resource?.options?.[0] || '').toLowerCase();
          const imageUrl = color === 'red' ? this.dataset.fallbackRed : color === 'blue' ? this.dataset.fallbackBlue : undefined;
          if (image instanceof HTMLImageElement && imageUrl) { image.removeAttribute('srcset'); image.src = imageUrl; image.alt = detail?.resource?.name || detail?.resource?.title || image.alt; }
          this.observePurchase();
          restoreFocus();
          this.pending = false;
          this.stickyVariantPending = false;
          this.querySelector('[data-collab-sticky]')?.setAttribute('aria-busy', 'false');
          const status = this.querySelector('[data-floating-status]');
          if (status) status.textContent = '';
          this.visibility();
        } catch (error) {
          if (generation !== this.generation || signal?.aborted) return;
          const status = this.querySelector('[data-floating-status]');
          if (status) status.textContent = this.dataset.updateError || '';
          this.observePurchase();
          restoreFocus();
          this.stickyVariantPending = false;
          this.querySelector('[data-collab-sticky]')?.setAttribute('aria-busy', 'false');
          this.visibility();
          // Preserve the disabled action until a later selection settles successfully.
        }
      }
      cleanup() { this.abort?.abort(); this.scrollAbort?.abort(); this.observer?.disconnect(); this.dialogs?.disconnect(); clearTimeout(this.timer); this.scrolling = false; }
      disconnectedCallback() { this.generation++; this.cleanup(); super.disconnectedCallback(); }
    
        }
        customElements.define("collab-purchase", CollabPurchase);
      };
      register().catch(error => console.error('Collaboration component failed to load', error));
    })();
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
